import CheckboxGroup from './CheckboxSelectorGroup';

export default CheckboxGroup;
